/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { modalContainer } from "@/src/theme/commonStyle";

const emailCheckStyle = {
  emailHelperText: {
    color: "#333",
    fontSize: "1rem",
  },
  modalContainer,
};

export default emailCheckStyle;
